












































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import firebase from 'firebase/app'
import 'firebase/auth'
@Component({
  name: 'Login'
})
export default class Login extends Vue {

  isLoading: boolean = false
  isLoginStatus: boolean | null = null

  signupEmail: string = ''
  signupPassword: string = ''
  signupConfirmPassword: string = ''
  signupResultMessage: string = ''
  isSignupShowPassword: boolean = false

  loginEmail: string = ''
  loginPassword: string = ''
  loginResultMessage: string = ''
  isLoginShowPassword: boolean = false

  LoginOrSigninMode: boolean = true
 
  mounted () {
    this.getItems()
  }

  getItems() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user !== null) {
        this.isLoginStatus = true
      } else {
        this.isLoginStatus = false
      }
    })
  }

  async onSignup() {
    this.isLoading = true
    await this.signup()
    this.isLoading = false
  }

  async signup() {
    try {
      this.signupResultMessage = ''
      const messages = this.validationSignup()
      if (messages.length !== 0) {
        messages.forEach((item) => {
          this.signupResultMessage += item + '<br>'
        })
        return 
      }
      const result = await firebase.auth().createUserWithEmailAndPassword(this.signupEmail, this.signupPassword)
      const user = firebase.auth().currentUser
      if (user !== null) {
        await user.sendEmailVerification()
        await this.createUser(user.uid)
        this.signupResultMessage = '完了メールを送信しました。'
      }
      this.$router.push({ name: 'Home' })
    } catch (error) {
      console.error(error)
    }
  }

  async createUser(userId: string) {
    try {
      const db: firebase.firestore.Firestore = firebase.firestore()
      const batch: firebase.firestore.WriteBatch = db.batch()
      const ref: firebase.firestore.DocumentReference = db.collection('users').doc(userId)
      batch.set(ref, {
        uid: userId,
        created: new Date(),
        updated: new Date(),
        name: 'ゲスト'
      }, { merge: true })
      await batch.commit()
    } catch (error) {
      console.error
    }
  }

  validationSignup(): string[] {
    const messages: string[] = []
    if (this.signupPassword.length < 6) {
      messages.push('パスワードは6文字以上です')
    } else if (this.signupPassword !== this.signupConfirmPassword) {
      messages.push('確認用パスワードが一致しません')
    }
    return messages
  }

  async onLogin() {
    this.isLoading = true
    await this.login()
    this.isLoading = false
  }

  async login() {
    try {
      this.loginResultMessage = ''
      const result = await firebase.auth().signInWithEmailAndPassword(this.loginEmail, this.loginPassword)
      const user = firebase.auth().currentUser
      if ( user !== null ) {
        await this.updateUser(user.uid)
      }
      this.$router.push({ name: 'Home'})
    } catch(error) {
      console.error(error)
    }
  }

  async updateUser(userId: string) {
    try {
      const db: firebase.firestore.Firestore = firebase.firestore()
      const batch: firebase.firestore.WriteBatch = db.batch()
      const ref: firebase.firestore.DocumentReference = db.collection('users').doc(userId)
      const item = await ref.get()
      if (item.exists) {
        batch.set(ref, {
          updatedAt: new Date
        }, { merge: true })
        await batch.commit()
      } else {
        throw new Error('ユーザ情報がありません、別のアカウントでログインしてください')
      }
    } catch (error) {
      throw error
    }
  }
  
  async signOut() {
    try {
      const result = firebase.auth().signOut()
      this.isLoginStatus = false
    } catch(error) {
      console.error(error)
    }
  }

  LoginMode() {
    this.LoginOrSigninMode = true
  }

  SigninMode() {
    this.LoginOrSigninMode = false
  }

  async TwitterLogin() {
    try {
      this.isLoading = true
      const provider = new firebase.auth.TwitterAuthProvider()
      const result = await firebase.auth().signInWithPopup(provider)
      console.log(result)
      const user = firebase.auth().currentUser
      if (user !== null) {
        console.log('user', user.uid)
      }
      this.$router.push({ name: 'Home' })
    } catch (error) {
      console.error(error)
    }
  }

  async FacebookLogin() {
    try {
      this.isLoading = true
      const provider = new firebase.auth.FacebookAuthProvider()
      const result = await firebase.auth().signInWithPopup(provider)
      console.log(result)
      const user = firebase.auth().currentUser
      if (user !== null) {
        console.log('user', user.uid)
      }
      this.$router.push({ name: 'Home' })
    } catch (error) {
      console.error(error)
    }
  }
}
